<span class="tezos-symbol" *ngIf="!currency">{{ tezosString }}</span> <span class="currency-symbol" *ngIf="currency"> {{ currency.symbol }}</span>
